var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-backtop',[_c('i',{staticClass:"el-icon-top",staticStyle:{"color":"#e70a16"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }